<script>
import { request,normalizeUrlParams } from 'dygc'
import Player from '@/components/player/Player.vue'

export default {
  name: 'Study',
  components: { Player },
  data() {
    return {
      studyName: '',
      duration: 0,
      videoEnd: false
    }
  },
  created() {
    const params = normalizeUrlParams()
    const videoUrl = params.videoUrl
    request.get('/study_video' + `${videoUrl ? `/${videoUrl}` : ''}`).then(res => {
      this.studyName = res.data
    })
  },
  computed: {
    studyUrl() {
      return `${window.origin}/fill/api/v1/download?fileName=${this.studyName}`
    },
    btnText({ duration }) {
      // console.log(duration)
      return duration > 0 ? `${duration}秒后开始` : '考试'
    }
  },
  methods: {
    onVideoLoad() {
      this.duration = Math.floor(this.$refs.videoRef.duration)
      // this.timer = setInterval(() => {
      //   this.duration--
      //   if (this.duration <= 0) {
      //     clearInterval(this.timer)
      //   }
      // }, 1000)
    },
    onExamination() {
      this.$router.replace({ name: 'Home' })
    },
    onVideoEnd() {
      this.videoEnd = true
    },
    onPlay() {
    },
    onPause() {
    },
    onTimeUpdate() {

    }
  }
}
</script>

<template>
  <div>

    <div>
      <Player :src="studyUrl" @ended="onVideoEnd"></Player>
      <!--      <div>-->
      <!--        <span>{{ duration }}</span>-->
      <!--      </div>-->
    </div>
    <div class="px-4">
      <el-button :disabled="!videoEnd" type="primary" @click="onExamination">
        <!--        {{ btnText }}-->
        <span>{{ videoEnd ? '考试' : '请先观看视频' }}</span>
      </el-button>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
